<template>
  <div class="container">
    <van-nav-bar class="header" :fixed="true" :title="lang.propertyTags" left-arrow @click-left="onClickLeft" />
    <div class="scroll_free">
      <div class="container_Box">
        <div class="container_Boxy">
          <div class="tag_ye">
            <span class="tag_y">{{lang.tag}}</span>
            <div class="tag_e">{{lang.alsel}}<span>{{tagcount}}</span>{{lang.ected}}</div>
          </div>
          <div :class="['tag_s',{en_s:language == 'en-us'}]" > <a href="#scrollEnd" style="color : #ED1C24;font-size:12px">{{lang.order}}</a> </div>
        </div>
        <!-- 單位特色 -->
        <div class="char_box same" v-if="propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '2' || propertyInfo.propertyCategory== 0 || propertyInfo.propertyCategory == '6'">
          <div class="tit">
            <span class="tit_y">{{lang.char}}</span>
            <span class="tit_e">{{lang.mofour}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsChar" :key="index"  :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{ selected: tagsChar.indexOf(item.dictionaryValue) != -1 },{dissel: tagsChar.length == 4 && tagsChar.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsChar', 4)">{{ item.dictionaryNameWithCulture }}</li>
            </ul>
          </div>
        </div>
        <!-- 景觀 -->
        <div class="sce_box same" v-if="propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == 2 || propertyInfo.propertyCategory== 0 || propertyInfo.propertyCategory == '6'">
          <div class="tit">
            <span class="tit_y">{{lang.sce}}</span>
            <span class="tit_e">{{lang.moone}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsSce" :key="index" :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{ selected: tagsSce.indexOf(item.dictionaryValue) != -1 },{dissel: tagsSce.length == 1 && tagsSce.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsSce', 1)">{{ item.dictionaryNameWithCulture }}</li>
            </ul>
          </div>
        </div>
        <!-- 裝修 -->
        <div class="ren_box same" v-if="propertyInfo.propertyCategory != '4' || propertyInfo.propertyCategory== 0">
          <div class="tit">
            <span class="tit_y">{{lang.ren}}</span>
            <span class="tit_e">{{lang.moone}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsRen" :key="index" :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{ selected: tagsRen.indexOf(item.dictionaryValue) != -1 },{dissel: tagsRen.length == 1 && tagsRen.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsRen', 1)">{{ item.dictionaryNameWithCulture }}</li>
            </ul>
          </div>
        </div>
        <!-- 配套 -->
        <div class="mat_box same" v-if="propertyInfo.propertyCategory != '4'">
          <div class="tit">
            <span class="tit_y">{{lang.mat}}</span>
            <span class="tit_e">{{lang.mothree}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsMat" :key="index" :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{subrain:item.dictionaryValue == 23 && subway > 15},{ selected: tagsMat.indexOf(item.dictionaryValue) != -1 },{dissel: tagsMat.length == 3 && tagsMat.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsMat', 3)">
                <p v-if="item.dictionaryValue==23" style="color:red ; display: inline-block;">#</p>{{ item.dictionaryNameWithCulture }}
                </li>
            </ul>
            <div v-if="subway>-1" class="tag_notice"><p style="color:red ; display: inline-block;">#</p>{{lang.notice}}{{subway}}{{lang.sub}}</div>
            <div v-if="subway>-1" class="tag_con">{{lang.foottime}}</div>
          </div>
        </div>
        <!-- 工商專用 -->
        <div class="bus_box same" v-if="propertyInfo.propertyCategory == '2' || propertyInfo.propertyCategory== 0">
          <div class="tit">
            <span class="tit_y">{{lang.bus}}</span>
            <span class="tit_e">{{lang.mothree}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsBus" :key="index" :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{nine:item.dictionaryValue == 29},{ selected: tagsBus.indexOf(item.dictionaryValue) != -1 },{dissel: tagsBus.length == 3 && tagsBus.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsBus', 3)">
                {{ item.dictionaryNameWithCulture }}
              </li>
            </ul>
          </div>
        </div>
        <!-- 车位专用 -->
        <div class="bus_box same" v-if="propertyInfo.propertyCategory == '4' || propertyInfo.propertyCategory== 0">
          <div class="tit">
            <span class="tit_y">{{lang.park}}</span>
            <span class="tit_e">{{lang.mosix}}</span>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in diConfig.tagsPark" :key="index" :class="[{subdis:propertyInfo.propertyCategory== 0},{enTags:language == 'en-us'},{subrain:item.dictionaryValue == 51 && subway > 15},{ selected: tagsPark.indexOf(item.dictionaryValue) != -1 },{dissel: tagsPark.length == 6 && tagsPark.indexOf(item.dictionaryValue) == -1}]" @click="CEchangeChar(item, 'tagsPark', 6)">
                <p v-if="item.dictionaryValue==51" style="color:red; display: inline-block;">#</p>{{ item.dictionaryNameWithCulture }}
              </li>
            </ul>
            <div v-if="subway>-1" class="tag_notice"><p style="color:red ; display: inline-block;">#</p>{{lang.notice}}{{subway}}{{lang.sub}}</div>
            <div v-if="subway>-1" class="tag_con">{{lang.foottime}}</div>
          </div>
        </div>
      </div>
      <div class="link-top"></div>
      <div class="tag_box">
        <div class="tag_tit">
            <div class="tag_red">
                <span>{{lang.alselected}}</span>
                <span>{{lang.showfive}}</span>
            </div>
            <div class="tag_gra">{{lang.drag}}</div>
        </div>
        <div class="draggable">
        <draggable chosenClass="chosen" @end='tagEnd' v-model="selectedTags" :disabled="draggableStart">
            <transition-group>
                <div  v-for="(item, index) in selectedTags" :class="['tags_warp',{enTags_warp:language == 'en-us'},{nine:item.key == 29}]"  :key="index">
                  {{item.val}}
                </div>
            </transition-group>
        </draggable>
        </div>
      </div>
      <div id="scrollEnd"></div>
    </div>
    <div class="footer">
      <van-button type="default" class="button" @click="cancel">{{ lang.clearAll }}</van-button>
      <van-button type="danger" class="button" @click="submitwords">{{ lang.confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import lang from './../../../common/language/post';
import draggable from 'vuedraggable';
export default {
  data() {
    return {
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      estateID:'',//获取港铁时间接口参数
      subway:'',//港铁时间
      // apiData:{
      //   propertyTags:[]
      // }
      draggableStart:false,
      lang,
      // 获取楼盘规则 所需的 楼盘类型 租售
      propertyInfo:{
        propertyCategory:0,
        rentalType:'',
        propertyTags:[],//页面选中之后，五个数组汇总的值，由他赋给selectedtags
        mode:''
      },
      selectedTags: [],//拖拽数据
      PostTagsData:{
        propertyTags:[]//刊登 复制 修改时候入vuex中的数据
      },
      //页面渲染所需字典
      diConfig:{
        tagsChar: [],
        tagsSce: [],
        tagsRen: [],
        tagsMat: [],
        tagsBus: [],
        tagsPark: [],
      },
      //页面五个小组中选值后会赋值的数组
      tagsChar: [],
      tagsSce: [],
      tagsRen: [],
      tagsMat: [],
      tagsBus: [],
      tagsPark: [],
      //修改时保存的 楼盘类型
      editPropertyCategory:'',
      flatTag: [],
    };
  },
  computed:{
    tagcount(){
      return this.selectedTags.length
    }
  },
  created() {
    this.estateID=this.store.state.estateInfo.estateID
    this.axios.post(this.pub.getApi().GetStationDuration,{estateId:this.estateID}).then(res => {
     this.subway=res.data.result
      this.initializeData();
    });
  },
  methods: {
    changeParkSub(){
      let arr={
        children: null,
        dictionaryNameWithCulture: "近港鐵",
        dictionaryValue: "51",
        itemName: "PropertyTagInfo",
        sequence: 13
      }
      if( this.subway == -1 || this.subway.length == 0 ){
        // 隐藏近港铁 改变原数组 删除了港铁
        if(this.diConfig.tagsPark.length){
          for (let i = 0; i < this.diConfig.tagsPark.length; i++) {
            if(this.diConfig.tagsPark[i].dictionaryValue == 51){
              this.diConfig.tagsPark.splice(i,1)
            }
          }
          for (let i = 0; i < this.tagsPark.length; i++) {
            if(this.tagsPark[i] == 51){
              this.tagsPark.splice(i,1)
            }
          }
          for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if(this.propertyInfo.propertyTags[i] == 51){
              this.propertyInfo.propertyTags.splice(i,1)
            }
          }
          for (let i = 0; i < this.selectedTags.length; i++) {
            if(this.selectedTags[i].key == 51 || this.selectedTags[i].propertyTagValue == 51 ){
              this.selectedTags.splice(i,1)
            }
          }
        }
      }else if(this.subway >15){
        // 大于15时，如果上次选中过，这次的需要置空
        for (let i = 0; i < this.tagsPark.length; i++) {
          if(this.tagsPark[i] == 51){
            this.tagsPark.splice(i,1)
          }
        }
        for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
          if(this.propertyInfo.propertyTags[i] == 51){
            this.propertyInfo.propertyTags.splice(i,1)
          }
        }
        for (let i = 0; i < this.selectedTags.length; i++) {
          if(this.selectedTags[i].key == 51){
            this.selectedTags.splice(i,1)
          }
        }
      }else{
        // 已隐藏的港铁 重新压入进行展示
        let flags=false
        this.diConfig.tagsPark.forEach(item=>{
          if(item.dictionaryValue == '51'){
              flags=true
          }
        })
        if(!flags){
          this.diConfig.tagsPark.unshift(arr)
        }
      }
    },
    //港铁显示规则：时间subway为-1时 不予展示。大于15时，禁用状态。小于15，可使用
    changesub(){
      let arr={
        children: null,
        dictionaryNameWithCulture: "近港鐵",
        dictionaryValue: "23",
        itemName: "PropertyTagInfo",
        sequence: 1
      }
      if( this.subway == -1 || this.subway.length == 0 ){
        // 隐藏近港铁 改变原数组 删除了港铁
        if(this.diConfig.tagsMat.length){
          for (let i = 0; i < this.diConfig.tagsMat.length; i++) {
            if(this.diConfig.tagsMat[i].dictionaryValue == 23){
              this.diConfig.tagsMat.splice(i,1)
            }
          }
          for (let i = 0; i < this.tagsMat.length; i++) {
            if(this.tagsMat[i] == 23){
              this.tagsMat.splice(i,1)
            }
          }
          for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if(this.propertyInfo.propertyTags[i] == 23){
              this.propertyInfo.propertyTags.splice(i,1)
            }
          }
          for (let i = 0; i < this.selectedTags.length; i++) {
            if(this.selectedTags[i].key == 23 || this.selectedTags[i].propertyTagValue == 23 ){
              this.selectedTags.splice(i,1)
            }
          }
        }
      }else if(this.subway >15){
        // 大于15时，如果上次选中过，这次的需要置空
        for (let i = 0; i < this.tagsMat.length; i++) {
          if(this.tagsMat[i] == 23){
            this.tagsMat.splice(i,1)
          }
        }
        for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
          if(this.propertyInfo.propertyTags[i] == 23){
            this.propertyInfo.propertyTags.splice(i,1)
          }
        }
        for (let i = 0; i < this.selectedTags.length; i++) {
          if(this.selectedTags[i].key == 23){
            this.selectedTags.splice(i,1)
          }
        }
      }else{
        // 已隐藏的港铁 重新压入进行展示
        let flags=false
        this.diConfig.tagsMat.forEach(item=>{
          if(item.dictionaryValue == '23'){
              flags=true
          }
        })
        if(!flags){
          this.diConfig.tagsMat.unshift(arr)
        }
      }
    },
    // 回显数据用，切割后分给5个小数组
  //  editTags(){
  //   //  this.apiData.propertyTags ||
  //     if(this.PostTagsData.propertyTags){
  //      this.propertyInfo.propertyTags=[]
  //      let k=false
  //      if(this.store.state.tags.length){
  //        // vuex中存在tags数据 如果其key值为key 则数据为点击确认后的数据 若不是 则是修改或者复制楼盘的数据
  //        k=this.store.state.tags[0].hasOwnProperty('key')
  //      }
  //      if (k){
  //         this.PostTagsData.propertyTags.forEach((ele)=>{
  //           let a= { key:ele.key,val:ele.val}
  //           this.selectedTags.push(a)
  //           this.propertyInfo.propertyTags.push(ele.key)
  //         })
  //       }else{
  //         // 修改 复制 立即付款楼盘时候格式
  //         this.PostTagsData.propertyTags.forEach((ele)=>{
  //           ele.propertyTagValue=String(ele.propertyTagValue)
  //           let a= { key:ele.propertyTagValue,val:ele.propertyTagName}
  //           this.selectedTags.push(a)
  //           this.propertyInfo.propertyTags.push(ele.propertyTagValue)
  //         })
  //       }
  //       for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
  //         if((this.propertyInfo.propertyTags[i]>=6 && this.propertyInfo.propertyTags[i] <=13) || this.propertyInfo.propertyTags[i]==34 || this.propertyInfo.propertyTags[i]==35 || this.propertyInfo.propertyTags[i]==37 || this.propertyInfo.propertyTags[i]==38 || this.propertyInfo.propertyTags[i]==36){
  //           this.tagsChar.push(this.propertyInfo.propertyTags[i])
  //         }else if(this.propertyInfo.propertyTags[i]>=14 && this.propertyInfo.propertyTags[i] <=19){
  //           this.tagsSce.push(this.propertyInfo.propertyTags[i])
  //         }else if(this.propertyInfo.propertyTags[i]>=20 && this.propertyInfo.propertyTags[i] <=22){
  //           this.tagsRen.push(this.propertyInfo.propertyTags[i])
  //         }else if(this.propertyInfo.propertyTags[i]>=23 && this.propertyInfo.propertyTags[i] <=28){
  //           this.tagsMat.push(this.propertyInfo.propertyTags[i])
  //         } else if(this.propertyInfo.propertyTags[i]>=29 && this.propertyInfo.propertyTags[i] <=33){
  //           this.tagsBus.push(this.propertyInfo.propertyTags[i])
  //         } else if(this.propertyInfo.propertyTags[i]>=39 && this.propertyInfo.propertyTags[i] <=51){
  //           this.tagsPark.push(this.propertyInfo.propertyTags[i])
  //         }
  //       }
  //       //住宅由租转售时候 若有连家电，复制楼盘时需要将连家电剔除
  //       if(this.propertyInfo.rentalType == 1 && this.propertyInfo.propertyCategory == '1'){
  //         for(var i=0;i<this.selectedTags.length;i++){
  //           if(this.selectedTags[i].key == '24'){
  //             this.selectedTags.splice(i, 1)
  //           }
  //         }
  //         for(var p=0;p<this.propertyInfo.propertyTags.length;p++){
  //           if(this.propertyInfo.propertyTags[p] == '24'){
  //             this.propertyInfo.propertyTags.splice(p, 1)
  //           }
  //         }
  //         for(var z=0;z<this.tagsMat.length;z++){
  //           if(this.tagsMat[z] == '24'){
  //             this.tagsMat.splice(z, 1)
  //             if(this.tagsMat.length == 0){
  //               this.tagsMat = []
  //             }
  //           }
  //         }
  //       }
  //     }
  //   },
    CEeditTags(){
      if (this.PostTagsData.propertyTags) {
        this.propertyInfo.propertyTags = []
        let k=false
       if(this.store.state.tags.length){
         // vuex中存在tags数据 如果其key值为key 则数据为点击确认后的数据 若不是 则是修改或者复制楼盘的数据
         k=this.store.state.tags[0].hasOwnProperty('key')
       }
       if (k){
          this.PostTagsData.propertyTags.forEach((ele)=>{
            let a= { key:ele.key,val:ele.val}
            this.selectedTags.push(a)
            this.propertyInfo.propertyTags.push(ele.key)
          })
        }else{
          // 修改 复制 立即付款楼盘时候格式
          this.PostTagsData.propertyTags.forEach((ele)=>{
            ele.propertyTagValue=String(ele.propertyTagValue)
            let a= { key:ele.propertyTagValue,val:ele.propertyTagName}
            this.selectedTags.push(a)
            this.propertyInfo.propertyTags.push(ele.propertyTagValue)
          })
        }
        
        this.tagsChar = this.diConfig.tagsChar.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsSce = this.diConfig.tagsSce.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsRen = this.diConfig.tagsRen.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsMat = this.diConfig.tagsMat.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsBus = this.diConfig.tagsBus.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsPark = this.diConfig.tagsPark.filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        //住宅由租转售时候 若有连家电复制楼盘时需要将连家电剔除
        if (this.propertyInfo.rentalType == 1 && (this.propertyInfo.propertyCategory == '1' || this.propertyInfo.propertyCategory == '6')) {
          for (var i = 0; i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].key == '24') {
              this.selectedTags.splice(i, 1)
            }
          }
          for (var i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if (this.propertyInfo.propertyTags[i] == '24') {
              this.propertyInfo.propertyTags.splice(i, 1)
            }
          }
          for (var z = 0; z < this.tagsMat.length; z++) {
            if (this.tagsMat[z] == '24') {
              this.tagsMat.splice(z, 1)
              if (this.tagsMat.length == 0) {
                this.tagsMat = []
              }
            }
          }
        }
      }
    },
    // 对选中后的数据进行去重
    unique1(arr){
      var hash=[];
      for (var i = 0; i < arr.length; i++) {
         if(hash.indexOf(arr[i])==-1){
          hash.push(arr[i]);
         }
      }
      console.log(hash,"选中的数据");
      this.propertyInfo.propertyTags=hash
      return hash;
    },
    // 数据选中后 赋值给可拖拽数据 对可拖拽数据加key value
    changeSelectedT(){
      if(this.propertyInfo.propertyTags.length==0){
        this.selectedTags=[]
      }else{
        this.propertyInfo.propertyTags=this.propertyInfo.propertyTags.toString().split(",")
        this.unique1(this.propertyInfo.propertyTags)
        this.selectedTags=JSON.parse(JSON.stringify(this.propertyInfo.propertyTags))
        this.selectedTags.forEach((ele, index) => {
          if((ele>=6 && ele<= 13) || (ele >= 34 && ele <= 38)){
            this.diConfig.tagsChar.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
          if(ele>13 && ele<= 19){
            this.diConfig.tagsSce.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
          if(ele>=20 && ele<=22){
            this.diConfig.tagsRen.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
          if(ele>=23 && ele<=28 ){
            this.diConfig.tagsMat.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
          if(ele>=29 && ele<= 33){
            this.diConfig.tagsBus.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
          if(ele>=39 && ele<= 51){
            this.diConfig.tagsPark.forEach(item => {
              if(ele === item.dictionaryValue) {
                let a= { key:ele,val:item.dictionaryNameWithCulture}
                this.selectedTags.splice(index,1,a)
              }
            })
          }
        })
      }
    },
    // 标签筛选方法
    filterTags(tagsArray, propertyCategory, rentalType, displayTypeOptions) {
      return tagsArray.filter(item => {
        const isInCategory = item.applyCategorys.includes(Number(propertyCategory));
        const isRentalTypeValid = item.rentalType === 0 || item.rentalType === rentalType;
        const isDisplayTypeValid = displayTypeOptions.includes(item.displayType);
        return isInCategory && isRentalTypeValid && isDisplayTypeValid;
      });
    },
    async initializeData() {
      await this.loadTagsMat();
      this.changesub();
      this.changeParkSub()
    },
    async loadTagsMat() {
      const res = await this.axios.get(this.pub.getApi().SearchDictionaryInfo, {params: {itemName: 'propertyTag'}})
      if (res.data.code == 0 && res.data.result) {
        this.diConfig.tagsChar = res.data.result[0].children;
        this.diConfig.tagsSce = res.data.result[1].children;
        this.diConfig.tagsRen = res.data.result[2].children;
        this.diConfig.tagsMat = res.data.result[3].children;
        this.diConfig.tagsBus = res.data.result[4].children;
        this.diConfig.tagsPark = res.data.result[5].children;
        this.flatTag = res.data.result.flatMap(obj=>obj.children)
        if(this.store.state.tagsConfig.propertyCategory){
          //点击确认后 tagsconfig会有值 修改楼盘类型 置空selectedtags  4
          if(this.store.state.tagsConfig.propertyCategory != this.store.state.propertyCategory) {
            this.selectedTags=[]
            this.store.commit("setTags",this.selectedTags)
          }
        }
        // 如果有值 证明是修改初次进入该页面 进入楼盘标签在退出之后,选择别的楼盘类型应该置空
        if(this.store.state.editPropertyCategory){
          if((this.store.state.editPropertyCategory != this.store.state.propertyCategory) ) {
          this.selectedTags=[]
          this.store.commit("setTags",this.selectedTags)
          }
        }

        // 获取当前楼盘类型
        this.propertyInfo.propertyCategory=this.store.state.propertyCategory
        this.propertyInfo.rentalType=this.store.state.rentalType
        // setCategory通过此 action,后改为setmode
        this.propertyInfo.mode=this.store.state.mode

        // 刊登楼盘时候
        this.tagshow()
        // vuex中存在数据 则需要回显
        if(this.store.state.tags){
          // 刊登楼盘时候
          this.PostTagsData.propertyTags=this.store.state.tags
          this.CEeditTags()
          // this.editTags()
        }
      }
    },
    // 初始页面对后台返回数据规则相关筛选规则
    tagshow(){
      // 标签相关展示规则
      this.selectedTags=[]
      this.tagsChar=[]
      this.tagsSce=[]
      this.tagsRen=[]
      this.tagsMat=[]
      this.tagsBus=[]
      this.tagsPark=[]
      if (this.propertyInfo.propertyCategory) {
        const displayTypeOptions = [0, 2];
        if (this.propertyInfo.rentalType === 1) {
          this.diConfig.tagsChar = this.filterTags(this.diConfig.tagsChar, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
          this.diConfig.tagsSce = this.filterTags(this.diConfig.tagsSce, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
          this.diConfig.tagsRen = this.filterTags(this.diConfig.tagsRen, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
          this.diConfig.tagsMat = this.filterTags(this.diConfig.tagsMat, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
          this.diConfig.tagsBus = this.filterTags(this.diConfig.tagsBus, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
          this.diConfig.tagsPark = this.filterTags(this.diConfig.tagsPark, this.propertyInfo.propertyCategory, 1, displayTypeOptions);
        } else if (this.propertyInfo.rentalType === 2) {
          this.diConfig.tagsChar = this.filterTags(this.diConfig.tagsChar, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
          this.diConfig.tagsSce = this.filterTags(this.diConfig.tagsSce, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
          this.diConfig.tagsRen = this.filterTags(this.diConfig.tagsRen, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
          this.diConfig.tagsMat = this.filterTags(this.diConfig.tagsMat, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
          this.diConfig.tagsBus = this.filterTags(this.diConfig.tagsBus, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
          this.diConfig.tagsPark = this.filterTags(this.diConfig.tagsPark, this.propertyInfo.propertyCategory, 2, displayTypeOptions);
        }
      }
    
      // if(this.propertyInfo.propertyCategory == 2){
      //   let feature=[]
      //   feature =this.diConfig.tagsChar.filter((item) => { 
      //     return item.applyCategorys.includes(Number(this.propertyInfo.propertyCategory))
      //   })
      //     // return item.dictionaryValue == '6' || item.dictionaryValue == '11' || item.dictionaryValue == '12'|| item.dictionaryValue == '9'|| item.dictionaryValue == '10'|| item.dictionaryValue == '7'})
      //     console.log("feature",feature)
      //   this.diConfig.tagsChar=feature
      // }
      // if(this.propertyInfo.rentalType == 1 && this.propertyInfo.propertyCategory == '1'){
      //   let match=[]
      //   match =this.diConfig.tagsMat.filter(function(item){ return item.dictionaryValue !=='24' })
      //   this.diConfig.tagsMat=match
      // }
      // // 工商厦和店铺仅仅显示港铁和大型商场
      // if(this.propertyInfo.propertyCategory == 2 || this.propertyInfo.propertyCategory == '3'){
      //   if(this.diConfig.tagsMat){
      //       var newarr =this.diConfig.tagsMat.filter(function(item){ return item.dictionaryValue==23 ||item.dictionaryValue==28})
      //   }
      //   this.diConfig.tagsMat=newarr
    
      //   console.log("newarr",newarr)
      // }
    },
    // 选中后的小数组 数据
    changeChar(n,value) {
      if (this.tagsChar.indexOf(value.dictionaryValue) != -1) {
        this.tagsChar.splice(this.tagsChar.indexOf(value.dictionaryValue), 1);
      } else {
        if ( this.tagsChar.length >= 4) {
          return false;
        } else {
          this.tagsChar.push(value.dictionaryValue);
        }
      }
      if(this.propertyInfo.propertyTags !=''){
        for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
          if((this.propertyInfo.propertyTags[i]>=6 && this.propertyInfo.propertyTags[i] <=13) || (this.propertyInfo.propertyTags[i]>=34 && this.propertyInfo.propertyTags[i] <=38)){
            // 现选比上次的少 则减少
            let b=this.tagsChar.indexOf(this.propertyInfo.propertyTags[i])
            if(b==-1){
              this.propertyInfo.propertyTags.splice(i,1);
            }
          }
          if((this.tagsChar[i]>=6 && this.tagsChar[i] <=13) || (this.tagsChar[i]>=34 && this.tagsChar[i] <=38)){
              for (let t = 0; t < this.tagsChar.length; t++) {
                // 现选的比上次的多 则压入
                let c=this.propertyInfo.propertyTags.indexOf(this.tagsChar[t])
                if(c==-1){
                  this.propertyInfo.propertyTags.push(this.tagsChar[t])
                }
              }
          }
        }
      }else if(this.tagsChar !=''){
        this.propertyInfo.propertyTags.push(this.tagsChar)
      }else{
        this.propertyInfo.propertyTags=[]
      }
      this.changeSelectedT()
    },
    // 刊登 楼盘标签
    CEchangeChar(value,targetarr,maxlimit){
      if (this[targetarr].indexOf(value.dictionaryValue) != -1) {
        this[targetarr].splice(this[targetarr].indexOf(value.dictionaryValue), 1);
      } else {
        if ( this[targetarr].length >= maxlimit) {
          return false;
        } else {
          this[targetarr].push(value.dictionaryValue);
        }
      }
      let filterArr = this.diConfig[targetarr].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
      if(filterArr.length > this[targetarr].length){
        filterArr.filter((item,index) => {
          if(!this[targetarr].includes(item)){
            this.propertyInfo.propertyTags.splice(this.propertyInfo.propertyTags.indexOf(item),1)
          }
        })
      }else{
        this[targetarr].filter((item,index)=>{
          if(!filterArr.includes(item)){
            this.propertyInfo.propertyTags.push(item)
          }
        })
      }
      if(this.propertyInfo.propertyTags && this.propertyInfo.propertyTags.length != 0){
        this.propertyInfo.propertyTags = this.propertyInfo.propertyTags.toString().split(",")
        this.unique1(this.propertyInfo.propertyTags)
        if (this.propertyInfo.propertyTags.length == 0) {
          this.selectedTags = []
        } else{
          this.selectedTags = JSON.parse(JSON.stringify(this.propertyInfo.propertyTags))
          this.selectedTags.forEach((ele, index) => {
            this.flatTag.forEach(item => {
              if (ele === item.dictionaryValue) {
                let a = { key: ele, val: item.dictionaryNameWithCulture }
                this.selectedTags.splice(index, 1, a)
              }
            })
          })
        }
      }else{
        this.selectedTags = []
      }
    },
    // changeSce(n,value){
    //   if (this.tagsSce.indexOf(value.dictionaryValue) != -1) {
    //     this.tagsSce.splice(this.tagsSce.indexOf(value.dictionaryValue), 1);
    //   } else {
    //     if ( this.tagsSce.length >= 1) {
    //       return false;
    //     } else {
    //       this.tagsSce.push(value.dictionaryValue);
    //     }
    //   }
    //   if(this.propertyInfo.propertyTags !=''){
    //     for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
    //       if(this.propertyInfo.propertyTags[i]>=14 && this.propertyInfo.propertyTags[i] <=19){
    //         let b=this.tagsSce.indexOf(this.propertyInfo.propertyTags[i])
    //         if(b==-1){
    //           this.propertyInfo.propertyTags.splice(i,1);
    //         }
    //       }
    //       if(this.tagsSce[i]>=14 && this.tagsSce[i] <=19){
    //           for (let t = 0; t < this.tagsSce.length; t++) {
    //             let c=this.propertyInfo.propertyTags.indexOf(this.tagsSce[t])
    //             if(c==-1){
    //               this.propertyInfo.propertyTags.push(this.tagsSce[t])
    //             }
    //           }
    //       }
    //     }
    //   }else if(this.tagsSce !=''){
    //     this.propertyInfo.propertyTags.push(this.tagsSce)
    //   }else{
    //     this.propertyInfo.propertyTags=[]
    //   }
    //   this.changeSelectedT()
    // },
    // changeRen(n,value){
    //     if (this.tagsRen.indexOf(value.dictionaryValue) != -1) {
    //     this.tagsRen.splice(this.tagsRen.indexOf(value.dictionaryValue), 1);
    //   } else {
    //     if ( this.tagsRen.length >= 1) {
    //       return false;
    //     } else {
    //       this.tagsRen.push(value.dictionaryValue);
    //     }
    //   }
    //   if(this.propertyInfo.propertyTags !=''){
    //     for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
    //       if(this.propertyInfo.propertyTags[i]>=20 && this.propertyInfo.propertyTags[i] <=22){
    //         let b=this.tagsRen.indexOf(this.propertyInfo.propertyTags[i])
    //         if(b==-1){
    //           this.propertyInfo.propertyTags.splice(i,1);
    //         }
    //       }
    //       if(this.tagsRen[i]>=20 && this.tagsRen[i] <=22){
    //           for (let t = 0; t < this.tagsRen.length; t++) {
    //             let c=this.propertyInfo.propertyTags.indexOf(this.tagsRen[t])
    //             if(c==-1){
    //               this.propertyInfo.propertyTags.push(this.tagsRen[t])
    //             }
    //           }
    //       }
    //     }
    //   }else if(this.tagsRen !=''){
    //     this.propertyInfo.propertyTags.push(this.tagsRen)
    //   }else{
    //     this.propertyInfo.propertyTags=[]
    //   }
    //   this.changeSelectedT()
    // },
    // changeMat(n,value){
    //     if (this.tagsMat.indexOf(value.dictionaryValue) != -1) {
    //     this.tagsMat.splice(this.tagsMat.indexOf(value.dictionaryValue), 1);
    //   } else {
    //     if ( this.tagsMat.length >= 3) {
    //       return false;
    //     } else {
    //       this.tagsMat.push(value.dictionaryValue);
    //     }
    //   }
    //   if(this.propertyInfo.propertyTags !=''){
    //     for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
    //       if(this.propertyInfo.propertyTags[i]>=23 && this.propertyInfo.propertyTags[i] <=28){
    //         let b=this.tagsMat.indexOf(this.propertyInfo.propertyTags[i])
    //         if(b==-1){
    //           this.propertyInfo.propertyTags.splice(i,1);
    //         }
    //       }
    //       if(this.tagsMat[i]>=23 && this.tagsMat[i] <=28){
    //           for (let t = 0; t < this.tagsMat.length; t++) {
    //             let c=this.propertyInfo.propertyTags.indexOf(this.tagsMat[t])
    //             if(c==-1){
    //               this.propertyInfo.propertyTags.push(this.tagsMat[t])
    //             }
    //           }
    //       }
    //     }
    //   }else if(this.tagsMat !=''){
    //     this.propertyInfo.propertyTags.push(this.tagsMat)
    //   }else{
    //     this.propertyInfo.propertyTags=[]
    //   }
    //   this.changeSelectedT()
    // },
    // changeBus(n,value){
    //     if (this.tagsBus.indexOf(value.dictionaryValue) != -1) {
    //     this.tagsBus.splice(this.tagsBus.indexOf(value.dictionaryValue), 1);
    //   } else {
    //     if ( this.tagsBus.length >= 3) {
    //       return false;
    //     } else {
    //       this.tagsBus.push(value.dictionaryValue);
    //     }
    //   }
    //   if(this.propertyInfo.propertyTags !=''){
    //     for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
    //       if(this.propertyInfo.propertyTags[i]>=29 && this.propertyInfo.propertyTags[i] <=33){
    //         let b=this.tagsBus.indexOf(this.propertyInfo.propertyTags[i])
    //         if(b==-1){
    //           this.propertyInfo.propertyTags.splice(i,1);
    //         }
    //       }
    //       if(this.tagsBus[i]>=29 && this.tagsBus[i] <=33){
    //           for (let t = 0; t < this.tagsBus.length; t++) {
    //             let c=this.propertyInfo.propertyTags.indexOf(this.tagsBus[t])
    //             if(c==-1){
    //               this.propertyInfo.propertyTags.push(this.tagsBus[t])
    //             }
    //           }
    //       }
    //     }
    //   }else if(this.tagsBus!=''){
    //     this.propertyInfo.propertyTags.push(this.tagsBus)
    //   }else{
    //     this.propertyInfo.propertyTags=[]
    //   }
    //   this.changeSelectedT()
    // },
    // changePark(n,value){
    //   if (this.tagsPark.indexOf(value.dictionaryValue) != -1) {
    //     this.tagsPark.splice(this.tagsPark.indexOf(value.dictionaryValue), 1);
    //   } else {
    //     if ( this.tagsPark.length >= 6) {
    //       return false;
    //     } else {
    //       this.tagsPark.push(value.dictionaryValue);
    //     }
    //   }
    //   if(this.propertyInfo.propertyTags !=''){
    //     for (var i = this.propertyInfo.propertyTags.length-1;i >= 0 ;i--) {
    //       if(this.propertyInfo.propertyTags[i]>=39 && this.propertyInfo.propertyTags[i] <=51){
    //         let b=this.tagsPark.indexOf(this.propertyInfo.propertyTags[i])
    //         if(b==-1){
    //           this.propertyInfo.propertyTags.splice(i,1);
    //         }
    //       }
    //       if(this.tagsPark[i]>=39 && this.tagsPark[i] <=51){
    //           for (let t = 0; t < this.tagsPark.length; t++) {
    //             let c=this.propertyInfo.propertyTags.indexOf(this.tagsPark[t])
    //             if(c==-1){
    //               this.propertyInfo.propertyTags.push(this.tagsPark[t])
    //             }
    //           }
    //       }
    //     }
    //   }else if(this.tagsPark!=''){
    //     this.propertyInfo.propertyTags.push(this.tagsPark)
    //   }else{
    //     this.propertyInfo.propertyTags=[]
    //   }
    //   this.changeSelectedT()
    // },
    // 拖拽结束
    tagEnd(){
      let newArr = this.selectedTags.map(item=>item.key)
      this.propertyInfo.propertyTags = newArr
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 取消所有选项
    cancel(){
      this.selectedTags=[]
      this.propertyInfo.propertyTags=[]
      this.tagsChar=[]
      this.tagsSce=[]
      this.tagsRen=[]
      this.tagsMat=[]
      this.tagsBus=[]
      this.tagsPark=[]
    },
    submitwords(){
      this.store.commit("setTags",this.selectedTags)
      this.store.commit("setTagsCount",this.tagcount)
      this.store.commit('setEditCate',{editPropertyCategory:this.editPropertyCategory})
      this.store.commit('setProCate',{propertyCategory:this.propertyInfo.propertyCategory})
      // propertyCategory:this.propertyInfo.propertyCategory,
      this.store.commit("setTagsConfig",{propertyTags:this.propertyInfo.propertyTags})
      this.$router.go(-1)
    }
  },
};
</script>

<style scoped lang="scss">
.subdis{
  color:#999999;
  background-color: #F7F7F7;
  pointer-events: none;
}
#scrollEnd{
  width: 100%;
  height: 20px;
  // background-color: red;
}
.scroll_free{
  width: 100%;//香港验收 无法兼容ipad 0706
  position: absolute;
  top:0;
  bottom: 50px;
  left: 0;
  overflow: auto;
}
.container_Box {
  margin-top: 75px;
  margin-left: 20px;
  margin-right: 20px;
  .container_Boxy {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .tag_ye {
      .tag_y {
        font-size: 20px;
        color: #171725;
      }
      .tag_e {
        display: inline-block;
        font-size: 17px;
        color: #696974;
        margin-left: 15px;
        span {
          color: #ED1C24;
        }
      }
    }
    .tag_s {
      width: 76px;
      height: 16px;
      line-height: 15px;
      display: inline-block;
      // font-size: 10px;
      border: 1px solid #ED1C24;
      border-radius: 5px;
    }
    .en_s{
       width: 90px !important;
    }
  }
  .same {
    margin-top: 20px;
  }
  .tit_y {
    font-size: 17px;
    color: #171725;
  }
  .tit_e {
    font-size: 17px;
    color: #696974;
    margin-left: 15px;
  }
  .tit {
    text-align: left;
    margin-bottom: 15px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  ul:after {
    content: '';
    width: 30%;
  }
  ul li {
    width: 30%;
    height: 30px;
    opacity: 1;
    font-weight: 400;
    font-family: PingFangSC, PingFangSC-Regular;
    text-align: center;
    line-height: 32px;
    margin-bottom: 10px;
    font-size: 16px;
    display: inline-block;
    border: 1px solid #B5B5BE;
  }
}
.link-top{
  height: 16px;
  background-color:#F5F6F7;
  width: 100%;
}
.tag_box{
  margin-left: 20px;
  margin-right: 20px;
  .tag_tit{
      text-align: left;
      .tag_red{
          margin-top: 9px;
      }
      .tag_red span:nth-child(1){color:#333333; font-size: 14px; text-align: left;margin-right: 10px;}
      .tag_red span:nth-child(2){color:#ff0000; font-size: 14px;}
  }
  .tag_gra{
      font-size: 12px;
      color: #999999;
      margin-top: 8px;
      margin-bottom: 10px;
  }
  .draggable{
    width:100%;
    text-align: left;
    .chosen {
        border: 2px solid #ED1C24 !important;
        background-color: transparent;
    }
      .tags_warp{
        display: inline-block;
        margin-top: 10px;
        width: 29%;
        height: 30px;
        margin-right: 8px;
        border: 1px solid #B5B5BE;
        line-height: 32px;
        text-align: center;
        font-size: 16px;
        color: #565656;
      }
      .enTags_warp{
        width:45% !important;
        font-size: 12px !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
  }
}
.tag_notice{
  text-align: left;
  font-size: 12px;
}
.tag_con{
  height: 34px;
  line-height: 16px;
  margin-top: 5px;
  font-size: 10px;
  text-align: left;
}
.selected {
  color: #ffffff;
  background-color: #ED1C24;
}
.dissel {
  color:#999999;
  background-color: #F7F7F7;
}
.enTags{
  width:47% !important;
  font-size: 12px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.subrain{
  color:#999999;
  background-color: #F7F7F7;
  pointer-events: none;
}

.nine{
  width:60% !important
}
.footer {
  width: 100%;
  height: 50px;
  margin-top: 5px;
  position: fixed;
  bottom: 0;
  left: 0;
}
.footer button {
  width: 50%;
  height: 50px;
  margin: 0;
  padding: 0;
}
</style>
